import request from '@/utils/request'
import axios from 'axios'

export function quAdd(data) {
  return request({
    url: 'questions/single',
    method: 'post',
    data
  })
}

export function quPaging(params) {
  return request({
    url: '/questions/paging',
    method: 'get',
    params
  })
}

export function quUpdate(id, data) {
  return request({
    url: `/questions/${id}`,
    method: 'put',
    data
  })
}

export function quDel(id) {
  return request({
    url: `/questions/${id}`,
    method: 'delete'
  })
}

export function quBatchDel(ids) {
  return request({
    url: '/questions/batch',
    method: 'delete',
    data: { ids }
  })
}

export function quDetail(id) {
  return request({
    url: `questions/single/${id}`,
    method: 'get'
  })
}

export function quDetailbyKnowledge(knowledge) {
  return request({
    url: `questions/single/${knowledge}`,
    method: 'get'
  })
}

export function quDetailbyContent(content) {
  return request({
    url: '/questions/byContent',
    method: 'get',
    params: { content }
  })
}

export function importQue(repoId, formData) {
  return request({
    url: `/questions/import/${repoId}`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// export function importOcrQu(id, data) {
//   return request({
//     url: `questions/ocr/import/${id}`,
//     method: 'post',
//     data
//   })
// }

// fetchDetail, saveData
/**
 * 题库详情
 * @param data
 */
export function fetchDetail(id) {
  // eslint-disable-next-line no-undef
  return post('/exam/api/qu/qu/detail', { id: id })
}

/**
 * 保存题库
 * @param data
 */
export function saveData(data) {
  // eslint-disable-next-line no-undef
  return post('/exam/api/qu/qu/save', data)
}

export function saveOcrQuestions(data) {
  return request({
    url: '/questions/saveQuestions',
    method: 'post',
    data
  })
}

/**
 * 根据题库id查找题目
 * @param repoId 题库id
 * @returns 题目列表
 */
export function getQuestionsByRepoId(repoId) {
  return request({
    url: `/questions/byRepoId/${repoId}`,
    method: 'get'
  })
}

// 统计指定题库(repoId)的题目总数
export function countByRepoId(repoId) {
  return request({
    url: `/questions/countByRepoId/${repoId}`,
    method: 'get'
  })
}

// 获取题目列表（用于题库管理）
export function getQuestionList(params) {
  return request({
    url: '/questions/paging',
    method: 'get',
    params
  })
}

// 获取题目列表（支持分页和筛选）
export function getQuestions(params) {
  return request({
    url: '/questions/paging',
    method: 'get',
    params
  })
}

// 根据课程ID获取题目列表
export function getQuestionsByCourse(courseId, params = {}) {
  return request({
    url: `/questions/course/${courseId}`,
    method: 'get',
    params
  })
}

/**
 * 无尽模式推题接口
 * 优先推荐未做过的题目，其次推荐做错的题目
 * @param {Object} data - 请求参数
 * @param {number} data.userId - 用户ID
 * @param {number} data.repoId - 题库ID
 * @param {number[]} data.excludeIds - 需要排除的题目ID列表
 * @param {number} data.count - 请求题目数量，默认5
 * @returns 推荐的题目列表
 */
export function recommendEndlessQuestions(data) {
  return request({
    url: '/questions/endless/recommend',
    method: 'post',
    data
  })
}

// 批量根据number更新knowledge字段
export function batchUpdateKnowledgeByNumber(mappings, repoId) {
  return request({
    url: '/questions/batchUpdateKnowledgeByNumber',
    method: 'put',
    data: {
      mappings,
      repoId
    }
  })
}
